var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 0.697266C4.81064 0.697266 0.198242 5.30967 0.198242 10.9993C0.198242 16.6891 4.81064 21.3014 10.5003 21.3014C16.19 21.3014 20.8024 16.6891 20.8024 10.9993C20.8024 5.30967 16.19 0.697266 10.5003 0.697266Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1964 7.55666C11.1964 7.03889 10.7767 6.61914 10.2589 6.61914C9.74115 6.61914 9.32138 7.03889 9.32138 7.55666V10.3692H6.50881C5.99104 10.3692 5.57129 10.789 5.57129 11.3068C5.57129 11.8245 5.99104 12.2443 6.50881 12.2443H9.32138V15.0569C9.32138 15.5746 9.74115 15.9944 10.2589 15.9944C10.7767 15.9944 11.1964 15.5746 11.1964 15.0569V12.2443H14.009C14.5268 12.2443 14.9465 11.8245 14.9465 11.3068C14.9465 10.789 14.5268 10.3692 14.009 10.3692H11.1964V7.55666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon);
export default __webpack_public_path__ + "static/media/ADDICON.1f2ccf32c0ff35b7adba5fa5f5af2abe.svg";
export { ForwardRef as ReactComponent };